import { Therapy } from '@alberta/konexi-shared';

export function getAccountingMonth(date: Date): number {
  const thisMonth = date.getMonth();
  const monthIn7Days = date.getTime() + 7 * 24 * 60 * 60 * 1000;

  return thisMonth !== monthIn7Days ? monthIn7Days : thisMonth;
}

export function getStartAndEndDatesForMonthlyOrder(): { startDate: Date; endDate: Date } {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();
  let startDate: Date;
  let endDate: Date;

  if (today.getDate() <= 15) {
    // set start and end to current month
    startDate = new Date(year, month, 1);
    endDate = new Date(year, month + 1, 0); // Last day of the current month
  } else {
    // set start and end to next month
    startDate = new Date(year, month + 1, 1);
    endDate = new Date(year, month + 2, 0); // Last day of the next month
  }

  return { startDate, endDate };
}

// Calculate the delivery end date based on the therapy type
export function getDeliveryEndDate(startDate: Date, therapyId: number): Date {
  let range = 0;

  if (!startDate) {
    return;
  }

  switch (therapyId) {
    case Therapy.ASEPT:
      range = 10;
      break;
    case Therapy.PE:
    case Therapy.IV:
      range = 7;
      break;
    case Therapy.WV:
      range = 14;
      break;
    case Therapy.EE:
      range = 30;
      break;
    case Therapy.STO:
    case Therapy.TS:
    case Therapy.INKO:
    case Therapy.BEA:
    case Therapy.SON:
      range = 28;
      break;
    case Therapy.OSA:
    case Therapy.HH:
    case Therapy.ABS:
    case Therapy.PUE:
    case Therapy.SS:
    case Therapy.IUA:
      range = 30;
      break;

    default:
      range = 28;
  }
  return new Date(startDate.getTime() + range * 24 * 60 * 60 * 1000);
}
